import { IMDSCardProps, MDSCardSlotName } from "./card.types";
import {
  StyledButton,
  StyledCardContent,
  StyledCardHeader,
  StyledCardIcon,
  StyledCardRightAddon,
  StyledCardTitle,
  StyledCardDescription,
  StyledButtonContent,
  StyledCard,
} from "./card.style";
import { getSlots } from "@/mds/utils/slots";
import { MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { MDSIcon } from "@/mds/components/icon";

export function MDSCard(props: IMDSCardProps) {
  const { onPress, className, ...rest } = props;

  if (onPress) {
    return (
      <StyledButton {...rest} onPress={onPress}>
        <Content {...props} />
      </StyledButton>
    );
  }

  return (
    <StyledCard className={className}>
      <Content {...props} />
    </StyledCard>
  );
}

const Content = (props: IMDSCardProps) => {
  const { mdsIcon, title, description, children } = props;

  const rightAddon = getSlots(children, MDSCardSlotName.RightAddon);
  const content = getSlots(children, MDSCardSlotName.Content);

  const hasRightAddon = rightAddon.length > 0;
  const hasContent = content.length > 0;

  return (
    <StyledButtonContent>
      <StyledCardHeader>
        {mdsIcon && (
          <StyledCardIcon>
            {typeof mdsIcon === "function" ? mdsIcon() : <MDSIcon kind={mdsIcon} />}
          </StyledCardIcon>
        )}
        {title && (
          <StyledCardTitle variant={MDSTextVariant.HeaderS} weight={MDSTextWeight.SemiBold}>
            {title}
          </StyledCardTitle>
        )}
        {hasRightAddon && <StyledCardRightAddon>{rightAddon}</StyledCardRightAddon>}
      </StyledCardHeader>
      <div>
        {description && (
          <StyledCardDescription variant={MDSTextVariant.ParagraphS}>
            {description}
          </StyledCardDescription>
        )}
        {hasContent && <StyledCardContent>{content}</StyledCardContent>}
      </div>
    </StyledButtonContent>
  );
};
